<mat-form-field
  [appearance]="appearance || 'legacy'"
  class="w-full date-picker-field"
  [floatLabel]="!label ? 'always' : 'auto'"
>
  <mat-label class="mat-field-label">{{ label }}</mat-label>
  <input
    matInput
    [owlDateTimeTrigger]="rangePicker"
    [owlDateTime]="rangePicker"
    [selectMode]="'range'"
    [formControl]="formControl"
    fbDisableAutocomplete
    [placeholder]="placeholder"
    [required]="required"
    [readonly]="true"
    min="{{ min !== undefined ? min : min }}"
    [max]="maxDate || undefined"
    [fbDisableControl]="disable"
    (focusout)="onTouched()"
    [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
    [class.light-theme]="(_currentThemeSubject | async) === 'light'"
    class="date-input"
  />
  <button
    *ngIf="formControl.value && !withNoResetDateRange"
    tabindex="-1"
    type="button"
    mat-icon-button
    matSuffix
    (click)="onClear(); $event.stopPropagation(); $event.preventDefault()"
    [disabled]="disable || readonly"
  >
    <mat-icon [inline]="true">clear</mat-icon>
  </button>

  <mat-datepicker-toggle matSuffix tabindex="-1" [owlDateTimeTrigger]="rangePicker" class="date-picker-toggle">
    <mat-icon
      matDatepickerToggleIcon
      class="c-pointer picker-toggle"
      [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
      [class.light-theme]="(_currentThemeSubject | async) === 'light'"
    >
      calendar_month
    </mat-icon>
  </mat-datepicker-toggle>
  <owl-date-time
    [pickerType]="'calendar'"
    #rangePicker
    [panelClass]="(_currentThemeSubject | async) === 'dark' ? 'darkPicker' : 'lightPicker'"
  >
  </owl-date-time>
</mat-form-field>
